import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ActionName } from '../../../constants';
import { extractPreviewAction } from './extract-preview-action';
var extractActions = function extractActions(response, actionOptions) {
  var action = _defineProperty({}, ActionName.PreviewAction, extractPreviewAction(response, actionOptions));
  return Object.values(action).some(function (value) {
    return Boolean(value);
  }) ? action : undefined;
};
export default extractActions;